import React from 'react';
import { Input } from '../../../components/ui/input';
import styles from './ThemeTab.module.css';
import type { SliderFieldProps } from './theme-types';

export const SliderField: React.FC<SliderFieldProps> = ({
  label,
  value,
  min,
  max,
  step,
  unit,
  minHint,
  maxHint,
  onChange,
}) => {
  const inputId = React.useId();
  const fillPercent = ((value - min) / (max - min)) * 100;
  const trackGradient = `linear-gradient(to right, hsl(var(--primary)) 0%, hsl(var(--primary)) ${fillPercent}%, #e5e7eb ${fillPercent}%, #e5e7eb 100%)`;

  return (
    <div className={styles.slider}>
      <header>
        <label htmlFor={inputId}>{label}</label>
        <span>
          <Input
            id={inputId}
            type="number"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={e => {
              const raw = e.target.value === '' ? min : Number(e.target.value);
              onChange(Math.min(max, Math.max(min, raw)));
            }}
          />
          <span>{unit}</span>
        </span>
      </header>
      <input
        type="range"
        aria-label={label}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={e => onChange(Number(e.target.value))}
        style={{ background: trackGradient }}
      />
      <footer>
        <span>{minHint}</span>
        <span>{maxHint}</span>
      </footer>
    </div>
  );
};
